<template>
  <div class="quote-msg" v-if="Object.keys(quoteMsgContent).length > 0">
    <span style="padding-right: 5px;" v-if="quoteMsgName">{{ quoteMsgName }}：</span>
    <!-- 图片引用 -->
    <span v-if="quoteMsgContent.type === 3" class="quote-msg__image" 
      @click="handlePreview(quoteMsgContent)">
      {{ `[图片]${getJsonParse(props.quoteMsgContent.text).name}` }}
    </span>
    <!-- 文字引用 -->
    <span
      class="quote-msg__text"
      v-if="quoteMsgContent.type === 1"
      v-html="quoteMsgContent.text"
    ></span>
    <!-- 文件引用 -->
    <span @click="downloadFile(quoteMsgContent.text)" class="quote-msg__file" v-if="quoteMsgContent.type === 4">
      {{ `[文件]${getJsonParse(props.quoteMsgContent.text).name}` }}
    </span>
    <!-- 视频引用 -->
    <span v-if="quoteMsgContent.type === 6" @click="playerVideo" class="quote-msg__image">{{ `[视频]${getJsonParse(props.quoteMsgContent.text).name}` }}</span>
    <!-- 留言引用 -->
    <span v-if="quoteMsgContent.type === 11" class="quote-msg__leave-msg">
      {{ `[留言] ${quoteMsgContent.text.msgContent || ''}` }}
    </span>

    <!-- 图片预览 -->
    <el-image-viewer v-if="page.showPrevier" :url-list="[page.currentImg]" @close="page.showPrevier = false" />
    <!-- 视频预览 -->
    <video-dialog ref="videoDialogRef"/>
  </div>
</template>
<script setup>
import { defineProps, reactive, ref, computed, nextTick } from 'vue'
import videoDialog from './audio-dialog.vue'
import { downloadFile, isBase64URl } from '@/utils/index.js'
const props = defineProps({
  quoteMsgContent: {
    type: Object,
    default: () => {}
  }
})

const quoteMsgName = computed(() => {
  const name = props.quoteMsgContent.name || props.quoteMsgContent.fromName
  return name
})
const getJsonParse = (obj) => {
  if (typeof obj === 'object' && !Array.isArray(obj) && obj !== null) {
    return obj
  } else {
    return JSON.parse(obj)
  }
}

const page = reactive({
  currentImg: null,
  showPrevier: false,
  showVideo:false
})
// 预览
const handlePreview = (quoteMsgContent) => {
  const text = getJsonParse(quoteMsgContent.text)
  page.currentImg = text.url
  page.showPrevier = true
}

const videoDialogRef = ref()
const playerVideo = () => {
  nextTick(() => {
    const url = getJsonParse(props.quoteMsgContent.text).url
    videoDialogRef.value.open(url)
  })
}
</script>
<style lang="less" scoped>
.quote-msg {
  background: #e9e9e9;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 12px;
  color: #777777;
  margin-top: 10px;
  display: inline-block;
  max-width: 280px;
  &__image {
    cursor: pointer;
  }
  &__video {
    height: 50px;
  }
  &__file {
    cursor: pointer;
    color: #1e88f5;
  }
  &__text {
    :deep(*) {
      display: inherit;
      padding: 0;
      margin: 0;
      line-height: 21px;
    }
  }
  &__leave-msg {
    max-width: 150px;
    word-break: break-all;
  }
}
</style>
